import axios from 'axios'

class ProjetoApiClient {
    async buscarProjetos(filtro) {
        return axios.patch('api/projetos', filtro)
    }
}

export default new ProjetoApiClient()
